import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';

import constants from '../../constants';
import Typography from "@material-ui/core/Typography";
import {
  ColorAccent,
  ColorBlack,
  ColorBorder,
  ColorCardFieldHover,
  ColorCardFieldSelected,
  ColorClear,
  ColorField,
  ColorNegative,
  ColorTheme,
  ColorTitle,
  ColorWhite
} from "src/styles/Colors";
import DateTimeHelper from "../../utils/DateTimeHelper";
import {Button, LinearProgress, makeStyles, MenuItem, Paper} from "@material-ui/core";
import {
  baseStyles,
  BORDER_RADIUS,
  CARD_SPACING,
  changeNavColor,
  FIELD_SPACE,
  TOOLBAR_HEIGHT,
  TOOLBAR_HEIGHT_XS,
  withMultipleStyles
} from "src/styles/Styles";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import ValueHelper from "../../utils/ValueHelper";
import Menu from "@material-ui/core/Menu";
import DialogView from "../commons/DialogView";
import CircularProgress from "@material-ui/core/CircularProgress";
import SwipeableViews from 'react-swipeable-views';
import {virtualize} from 'react-swipeable-views-utils';
import AppText from "../commons/AppText";
import View from "../commons/View";
import {FontSizeSmall, FontSizeXSmall} from "src/res/FontSize";
import {FontWeightMedium, FontWeightRegular} from "src/res/FontWeight";
import {
  AppIcon,
  IconAdd,
  IconArrowUpLong,
  IconDotsV,
  IconDownload,
  IconHeart,
  IconHeartOutline,
  IconPaperPlane,
  IconPause,
  IconPlay,
  IconTrend,
  IconTrophy,
  IconUnmute,
  IconView
} from "../commons/AppIcon";
import AppUtils from "../../utils/AppUtils";
import {HeightElementMinimum, SpaceNormal, SpaceSmall, SpaceXSmall} from "../../../res/Spacing";
import {RadiusView, RadiusViewList} from "../../../res/Radius";
import AppImage from "../commons/AppImage";
import LinkHelper from "../../utils/LinkHelper";
import ReadMoreText from "../commons/ReadMoreText";
import TouchableOpacity from "../commons/TouchableOpacity";
import AppIconButton from "../commons/AppIconButton";
import {ImageIcon, locString, NavBackActionView, SNACKBAR_AUTO_HIDE_DURATION} from "../commons/ViewHelper";
import {
  ACTIVITY_TYPE_CHALLENGE,
  ACTIVITY_TYPE_CONTENT_WRITING,
  ACTIVITY_TYPE_VISITOR_OPINION,
  FEED_TYPE_POST,
  POST_TYPE_CHALLENGE
} from "../../constants/ApiConstants";
import VideoPlayer from "../commons/VideoPlayer";
import {API_AUDIO_DEFAULT_POSTER_URL} from "../../utils/services";
import {withStyles} from "@material-ui/core/styles";
import TextView from "../commons/TextView";
import FocusHelperView from "../commons/FocusHelperView";
import {connect} from "react-redux";
import {
  deleteActivityPost,
  downloadActivityPost,
  likeActivityPost,
  previewActivityPost
} from "../../actions/funActions";
import {downloadActivityPostBusiness} from "../../actions/activitiesActions";
import fileDownload from "js-file-download";
import ProgressLoader from "../commons/ProgressLoader";
import {GetLanguageSelectorView} from "../../utils/ActivityHelper";
import {animated, easings, SpringValue} from "@react-spring/web";
import Space from "src/js/components/commons/Space";
import mime from "mime-types";
import {logDebug} from "src/js/utils/AppLog";
import currentDevice from "current-device";
import Rating from "@material-ui/lab/Rating";
import {getErrorFromResponse} from "src/js/utils/ApiHelper";

const VirtualizeSwipeableViews = virtualize(SwipeableViews);

const PER_PAGE = 20;
const LOAD_MORE_BEFORE = 7;

const useStyles = (theme) => ({
  viewWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden'
  },
  viewWrapperPreview: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  cardItemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
  },
  cardItem: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    position: 'relative',
  },
  cardImage: {
    borderRadius: BORDER_RADIUS,
    backgroundColor: ColorField,
  },
  buttonAdd: {
    marginTop: CARD_SPACING/2,
    marginBottom: CARD_SPACING,
    fontWeight: 'bold',
    position: 'relative',
    overflow: 'hidden',
    padding: 8,
    paddingLeft: 24,
    paddingRight: 24,
  },
  messageBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: 400,
    alignItems: 'center',
    justifyContent: 'center',
    margin: 16,
  },
  menuItemBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 28
  },
  usageCardWrapper: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 1200,
  },
  usageCard: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    backgroundColor: ColorWhite,
    padding: 8,
    margin: 4,
    minHeight: 126,
    border: `1px solid rgba(0,0,0,0.05)`
  },
  usageCardButtonBase: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    padding: 8,
    minHeight: 100,
    border: `1px solid rgba(0,0,0,0.05)`,
    backgroundColor: ColorWhite,
    '&:hover': {
      backgroundColor: ColorCardFieldHover,
    },
  },
  usageCardImage: {
    width: 72,
    height: 72,
    borderRadius: BORDER_RADIUS,
    padding: 6,
    backgroundColor: ColorCardFieldHover,
    [theme.breakpoints.down('xs')]: {
      width: 52,
      height: 52,
    }
  },
  actionButtonIcon: {
    border: '1px solid ' + ColorCardFieldSelected, width: 40, height: 40, backgroundColor: ColorCardFieldHover,
    '&:hover': {
      backgroundColor: ColorCardFieldSelected,
    },
  },
});

const OpinionReadOnlyRating = withStyles({
  iconEmpty: {
    color: 'rgb(255,255,255,0.2)',
  },
  iconFilled: {
    color: 'rgb(255,255,255)',
  },
  iconHover: {
    color: 'rgb(255,255,255)',
  },
  fontSize: '3rem',
})(Rating);

const GetVideoPlayerView = React.memo(forwardRef((props, ref) => {

  const styles = makeStyles(() => ({
    colorPrimary: {
      backgroundColor: 'rgba(255,255,255,0.5)',
    },
    barColorPrimary: {
      backgroundColor: '#FFFFFF',
    },
    colorPrimaryI: {
      backgroundColor: ColorClear,
    },
    barColorPrimaryI: {
      backgroundColor: 'rgba(255,255,255,0.5)',
    }
  }));
  const classes = styles();

  const {videoUrl, videoPosterUrl, videoWidth, videoHeight, borderRadius} = props;

  const isIos = React.useRef(currentDevice.ios());
  const refVideo = useRef();
  const isInFocus = useRef(false);
  const hasInteraction = useRef(!isIos.current && props.index > 0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showIcon, setShowIcon] = useState(false);
  const [showMuteIcon, setShowMuteIcon] = useState(false);
  const [progress, setProgress] = useState(0);

  let videoJsOptions = null;
  let type = 'video/mp4';
  if (videoUrl.substring(videoUrl.lastIndexOf('.') + 1) === 'm3u8') {
    type = 'application/x-mpegURL';
  }

  videoJsOptions = {
    width: videoWidth,
    height: videoHeight,
    objectFit: 'contain',
    alignItems: 'center',
    justifyContent: 'center',
    style: {
      width: videoWidth,
      height: videoHeight,
      objectFit: 'contain',
      alignItems: 'center',
      justifyContent: 'center',
    },
    autoplay: false,
    controls: false,
    muted: true,
    loop: !props.inPreview,
    playsinline: true,
    disablePictureInPicture: true,
    // poster: videoPosterUrl,
    // children: {loadingSpinner: false},
    controlBar: {
      pictureInPictureToggle: false
    },
    sources: [
      {src: videoUrl, type: type},
    ],
    eListenerOnProgress: (progress) => {
      setProgress(progress);

    },
    eListenerOnError: () => {
      setProgress(1);
      setIsPlaying(false);
    },
    eListenerOnEnded: () => {
      if (props.onEnded) {
        props.onEnded();
      }
    },
    eListenerOnMuted: () => {
      setShowMuteIcon(true);
    },
  };

  useImperativeHandle(ref, () => ({
    play, pause, stop, isInPlay, setHasInteraction, onClicked
  }));

  const setHasInteraction = () => {
    if (!hasInteraction.current) {
      hasInteraction.current = true;
      if (refVideo && refVideo.current) {
        refVideo.current.play(false, () => {
          setTimeout(() => {
            if (!isInFocus.current) {
              refVideo.current.pause();
            }
          });
        });
      }
    }
  };

  const onClicked = (event) => {
    if (isInFocus.current) {
      logDebug('videoPlayer0-onClick', props.index);
      if (showIcon && !isPlaying) {
        onPlayPauseClicked(event);
      } else if (showMuteIcon) {
        onUnmuteClicked(event);
      } else {
        onPlayPauseClicked(event);
      }
    }
  }

  const play = () => {
    if (refVideo && refVideo.current && !isPlaying) {
      logDebug('videoPlayer0-playIt', props.index);
      isInFocus.current = true;
      refVideo.current.play(hasInteraction.current);
      if (!hasInteraction.current) {
        setShowMuteIcon(true);
      } else {
        setShowMuteIcon(false);
      }
      setShowIcon(false);
      setIsPlaying(true);
    }
  };

  const pause = () => {
    if (refVideo && refVideo.current) {
      logDebug('videoPlayer0-pauseIt', props.index);
      refVideo.current.pause();
      setShowIcon(true);
      setIsPlaying(false);
    }
  };

  const stop = () => {
    if (refVideo && refVideo.current) {
      logDebug('videoPlayer0-stopIt', props.index);
      isInFocus.current = false; // disable focus to prevent playing again on slide change and onclick event in desktop
      refVideo.current.pause();
      setIsPlaying(false);
    }
  };

  const isInPlay = () => {
    return isPlaying;
  };

  const onPlayPauseClicked = () => {
    hasInteraction.current = true;
    if (isInFocus.current) {
      if (refVideo && refVideo.current && refVideo.current.isPaused()) {
        refVideo.current.play(true);
        setTimeout(() => {
          setIsPlaying(true);
          setShowIcon(false);
        }, 300);
      } else {
        setShowIcon(true);
        setTimeout(() => {
          refVideo.current.pause();
          setShowIcon(false);
        }, 300);
        setTimeout(() => {
          setShowIcon(true);
          setIsPlaying(false);
        }, 600);
      }
    }
  }

  const onUnmuteClicked = () => {
    hasInteraction.current = true;
    if (isInFocus.current) {
      if (refVideo && refVideo.current) {
        refVideo.current.unmute();
        setShowMuteIcon(false);
      }
    }
  }

  const onNextVideoTouchStart = () => {
    logDebug('videoPlayer0-onNextTouchStart', props.index);
    props.onNextVideoTouchStart(2);
  };

  const onNextVideoClick = () => {
    logDebug('videoPlayer0-onNextClick', props.index);
    props.onNextVideoClick();
  };

  const onCurrentVideoClick = () => {
    onClicked();
  };

  const viewWrapperHeight = videoHeight + props.marginTop + props.marginBottom;
  const translucentColor = 'rgba(0,0,0,0.1)';
  let iconHover = null;
  if (showIcon && !isPlaying) {
    iconHover = IconPlay;
  } else if (showMuteIcon) {
    iconHover = IconUnmute;
  } else if (showIcon) {
    iconHover = IconPause;
  }
  return <View ref={ref} style={{position: 'relative', display: 'flex', width: videoWidth, height: videoHeight, borderRadius: borderRadius, overflow: 'hidden'}}>
    {!isIos.current ?
      <div style={{width: '100%', height: '100%'}}>
        <VideoPlayer ref={refVideo} {...videoJsOptions} />
      </div>
      : <div style={{position: isInFocus.current ? 'absolute' : 'fixed', top: 0, bottom: 'auto', left: 0, right: 0, height: isInFocus.current ? videoHeight : viewWrapperHeight * 7, overflow: 'hidden'}}>
        <div style={{width: '100%', height: '100%', opacity: isInFocus.current ? 1 : 0}}>
          <VideoPlayer ref={refVideo} {...videoJsOptions} />
        </div>
        <div onTouchStart={onNextVideoTouchStart} onClick={onNextVideoClick} style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0}} />
      </div>
    }
    {videoPosterUrl ?
      <View style={{position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, flex: 1, width: videoWidth, height: videoHeight, borderRadius: borderRadius, overflow: 'hidden'}}>
        <AppImage
          draggable="false"
          style={{
            height: videoHeight,
            width: videoWidth,
            borderRadius: borderRadius,
          }}
          imageUrl={videoPosterUrl}
          resizeMode={'contain'}/>
      </View>
      : null
    }

    <TouchableOpacity onClick={onCurrentVideoClick} style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      {iconHover ?
        <View style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: 120, height: 120, borderRadius: 60, backgroundColor: translucentColor}}>
          <AppIcon icon={iconHover} size={'3x'} color={ColorWhite} />
        </View>
        : null
      }
    </TouchableOpacity>
    <div style={{position: 'absolute', bottom: 0, left: 0, right: 0, borderBottomLeftRadius: borderRadius, borderBottomRightRadius: borderRadius, overflow: 'hidden'}}>
      {progress > 0 ?
        <LinearProgress variant={'determinate'} value={progress} classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}}/>
        : <LinearProgress variant={'indeterminate'} value={progress} classes={{colorPrimary: classes.colorPrimaryI, barColorPrimary: classes.barColorPrimaryI}}/>
      }
    </div>
  </View>
}));

const COLOR_TEXT_BORDER = '#cdcac8';
const LinkButton = withStyles((theme) => ({
  root: {
    color: ColorTheme,
    backgroundColor: 'rgba(255,255,255,0.95)',
    borderRadius: RadiusViewList,
    marginBottom: SpaceSmall,
    paddingLeft: 20,
    paddingRight: 20,
    minHeight: 0,
    opacity: 0.9,
    borderWidth: '1px',
    borderColor: COLOR_TEXT_BORDER,
    borderStyle: 'solid',
    '&:hover': {
      backgroundColor: 'rgb(255,255,255)',
    },
  },
}))(Button);

const GetViewForItem = React.memo(forwardRef((props, ref) => {
  const {classes, isXS, uiConfigs, isLTR, width, height, index, item,
    disableLike, isAd, showCampaign, inPreview,
    showWinners, showRewardsWon,
    isWinningPost, isWinnersSelected, isShowingMixed,
    isInSameTrend, showShare, hideActions, showTrends, showDownload, showWinnerDownload, showMoreMenu, hideBack, backData, sponsorFrontData} = props;
  const {onLinkClick} = props;
  let {showAddPost, showRewards} = props;
  showAddPost = showAddPost && !isAd;
  showRewards = showRewards && !isAd;

  const refTimeout = useRef();
  const refVideo = useRef();
  const showSwipeUp = useRef(props.showSwipeUp);

  const [swipeUpBottom] = useState(new SpringValue(-120));
  // const [isLoaded, setIsLoaded] = useState(index <= 1);
  const [isLoaded, setIsLoaded] = useState(true);

  const onEnded = () => {
    if (showSwipeUp.current) {
      showSwipeUpView();
    }
  };

  const showSwipeUpView = (delay = 0) => {
    if (showSwipeUp.current > 1) {
      showSwipeUp.current = 0;
      swipeUpBottom.update({
        config: {
          duration: 400,
          easing: easings.easeOutBack,
        },
        delay: delay,
        to: 60 * sizeFactor,
      }).start().then(() => {
        swipeUpBottom.update({
          config: {
            duration: 1,
            easing: easings.easeOutBack,
          },
          delay: 4000,
          to: -120 * sizeFactor,
        }).start();
      });
    }
  }

  useEffect(() => {
    if (!isLoaded) {
      refTimeout.current = setTimeout(() => {
        refTimeout.current = null;
        setIsLoaded(true);
      }, 300);
    }
    if (showSwipeUp.current) {
      if (!refVideo || !refVideo.current) {
        showSwipeUpView(1500);
      }
    }

    return () => {
      if (refTimeout.current) {
        clearTimeout(refTimeout.current);
      }
    }
  }, []);

  useImperativeHandle(ref, () => ({
    play, pause, stop, isInPlay, setHasInteraction, onClicked
  }));

  const setHasInteraction = () => {
    if (refVideo && refVideo.current) {
      refVideo.current.setHasInteraction();
    }
  };

  const onClicked = () => {
    if (refVideo && refVideo.current) {
      refVideo.current.onClicked();
    }
  };

  const play = (hasInteraction) => {
    if (refVideo && refVideo.current) {
      refVideo.current.play(hasInteraction);
    }
  };

  const pause = () => {
    if (refVideo && refVideo.current) {
      refVideo.current.pause();
    }
  };

  const stop = (stopFocus) => {
    if (refVideo && refVideo.current) {
      refVideo.current.stop();
    }
  };

  const isInPlay = () => {
    if (refVideo && refVideo.current) {
      return refVideo.current.isInPlay();
    }
    return false;
  };

  const onActivityClicked = () => {
    props.onActivityClicked(item, index);
  };

  const onLikeClicked = () => {
    props.onLikeClicked(item, index);
  };

  const onShareClicked = () => {
    props.onShareClicked(item, index);
  };

  const onMoreClicked = (event) => {
    props.onMoreClicked(item, index, event.target);
  };

  const onRewardsClicked = () => {
    props.onRewardsClicked(item, index);
  };

  const onBusinessClicked = () => {
    props.onBusinessClicked(item, index);
  };

  const onRewardsWonClicked = () => {
    props.onRewardsWonClicked(item, index);
  };

  const onWinningPostClicked = () => {
    props.onWinningPostClicked(item, index);
  };

  const onWinnersClicked = () => {
    props.onWinnersClicked(item, index);
  };

  const onAddPostClicked = () => {
    props.onAddPostClicked(item, index);
  };

  const onTrendsClicked = () => {
    props.onTrendsClicked(item, index);
  };

  const onDownloadClicked = () => {
    props.onDownloadClicked(item, index, showWinnerDownload);
  };

  const onPromotedLinkClicked = () => {
    props.onPromotedLinkClicked(item, index);
  };

  const sizeFactor = Math.min(uiConfigs.sizeFactor, 1.5);
  const itemHeight = isXS ? height : height;
  const itemWidth = isXS ? width : itemHeight/16*9;

  let imageUrl = item.imageFiles && item.imageFiles.length > 0 ? item.imageFiles[0].url : (item.imageUrls && item.imageUrls.length > 0 ? item.imageUrls[0] : item.imageUrl);
  let audioUrl = item.audioFiles && item.audioFiles.length > 0 ? item.audioFiles[0].url : item.audioUrl;
  let videoUrl = item.videoFiles && item.videoFiles.length > 0 ? item.videoFiles[0].url : item.videoUrl;
  const videoStreamUrl = item.videoStreamUrl || videoUrl || audioUrl;
  const videoPosterUrl = (!item.videoStreamUrl && !videoUrl && audioUrl) ? imageUrl || API_AUDIO_DEFAULT_POSTER_URL : null;
  if (videoUrl || videoPosterUrl) {
    imageUrl = null;
  }

  let business = null;
  // if (!isAd) {
  if (item.isDummy) {
    business = item.business || (item.activity ? item.activity.business : null);
  }

  let timeSince = null;
  let name = null;
  let userImageUrl = null;
  if (item.createdBy) {
    name = item.createdBy.name;
    userImageUrl = item.createdBy.imageUrl;
    if (item.createdAt) {
      timeSince = DateTimeHelper.getTimeSinceWithAgo(item.createdAt);
    }
  }
  const text = imageUrl || videoStreamUrl ? null : item.title;
  const title = imageUrl || videoStreamUrl ? item.title : null;
  const details = item.details;
  const likesCount = ValueHelper.getDisplayValue(item.likesCount || 0, 1, true, true);
  const viewsCount = ValueHelper.getDisplayValue(item.viewCount || 0, 1, true, true);
  const commentsCount = ValueHelper.getDisplayValue(item.commentsCount || 0, 1, true, true);

  let canShare = showShare && !item.noShare;
  let canPublicAction = true;
  let isWin = false;
  if (item.isDummy) {
    canPublicAction = false;
  } else if (item.activity && item.activity.type === constants.activity.types.SOCIAL_CONTENT) {
    canPublicAction = false;
    isWin = item.downloadCount > 0;
  }
  const isDefaultPost = item.isDefaultPost;

  let likeColor = ColorAccent;
  let likeIcon = IconHeartOutline;
  if (item.like == 1) {
    likeColor = ColorAccent;
    likeIcon = IconHeart;
  }

  let linkButtonText = null;
  if (item.link) {
    linkButtonText = <FormattedMessage id={'activity.visitLink'}/>;
    if (props.ctaTitles) {
      props.ctaTitles.forEach((ctaTitle) => {
        if (ctaTitle.id == item.linkText) {
          linkButtonText = <FormattedMessage id={ctaTitle.nameId}/>;
        }
      });
    }
  }

  const showLikes = canPublicAction;
  const showViews = canPublicAction;
  const showActions = !hideActions && item.activity && (item.activity.type === constants.activity.types.CHALLENGE || item.activity.type === constants.activity.types.SOCIAL_CONTENT);
  const showActions1 = item.activity && item.activity.type === constants.activity.types.VISITOR_OPINION && showDownload;

  const translucentColor = 'rgba(0,0,0,0.1)';
  const imageSize = 28 * sizeFactor;
  const iconOuterWidth = 40 * sizeFactor;
  const iconSizePx = sizeFactor * 20;
  const iconSize = sizeFactor >= 1.4 ? '2xl' : sizeFactor <= 1 ? 'lg' : 'xl';
  const iconTextSpaceBottom = sizeFactor * 12;
  const iconSpaceBottom = sizeFactor * 16;
  const textShadowStyle = '0px 0px 2px #282828';

  const borderRadius = isXS ? 0 : BORDER_RADIUS;

  const marginTop = isXS ? 0 : 16;
  const marginBottom = isXS ? 0 : 16;
  const zIndex = 1;
  return (
    <div key={props.key} style={{width: '100%', height: '100%', maxHeight: props.maxHeight, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden'}}>
      <Paper elevation={isXS ? 0 : 1} className={classes.cardItemWrapper} style={{borderRadius: borderRadius, width: itemWidth, height: itemHeight, marginTop: marginTop, marginBottom: marginBottom, backgroundColor: ColorBlack, position: 'relative'}}>
        <View style={{flex: 1}}>
          {isLoaded ?
            <View style={{position: 'relative', flex: 1, justifyContent: 'center'}}>
              {imageUrl ?
                <View style={{flex: 1, width: itemWidth, height: itemHeight, borderRadius: borderRadius, overflow: 'hidden'}}>
                  <AppImage
                    draggable="false"
                    style={{
                      height: itemHeight,
                      width: itemWidth,
                      borderRadius: borderRadius,
                    }}
                    imageUrl={imageUrl}
                    resizeMode={'contain'}/>
                </View>
                : null
              }
              {videoStreamUrl ?
                <GetVideoPlayerView
                  ref={refVideo}
                  index={index}
                  marginTop={marginTop}
                  marginBottom={marginBottom}
                  inPreview={props.inPreview}
                  onNextVideoTouchStart={props.onNextVideoTouchStart}
                  onNextVideoClick={props.onNextVideoClick}
                  onEnded={onEnded}
                  videoUrl={videoStreamUrl}
                  videoPosterUrl={videoPosterUrl}
                  videoWidth={itemWidth}
                  videoHeight={itemHeight}
                  borderRadius={borderRadius}/>
                : null
              }
              {text ?
                <AppText
                  onLinkClick={onLinkClick}
                  fontSizeN={uiConfigs.fontSize}
                  variant={'body2'}
                  style={{textAlign: 'center', color: ColorWhite, fontWeight: FontWeightRegular, margin: SpaceNormal, textShadow: textShadowStyle}}>
                  {text}
                </AppText>
                : null
              }
              {details ?
                <View style={{pointerEvents: 'none', position: 'absolute', left: 0, right: 0, top: 60}}>
                  <View style={{pointerEvents: 'auto', flex: 1, padding: SpaceXSmall, paddingLeft: 16, paddingRight: 16}}>
                    <ReadMoreText
                      fontSizeN={uiConfigs.fontSize}
                      onLinkClick={onLinkClick}
                      color={ColorWhite}
                      minLines={4}
                      showCount={200}
                      text={details}
                      style={{textShadow: textShadowStyle}}
                      aStyle={{zIndex: zIndex}}
                    />
                  </View>
                </View>
                : null
              }
              <View style={{pointerEvents: 'none', position: 'absolute', left: 0, right: 0, bottom: 0, borderBottomLeftRadius: borderRadius, borderBottomRightRadius: borderRadius, overflow: 'hidden'}}>
                <View style={{flexDirection: isLTR ? 'row' : 'row-reverse', alignItems: 'flex-end'}}>
                  <View style={{flex: 1, marginLeft: !isLTR ? 8 : 0, marginRight: isLTR ? 8 : 0, padding: SpaceXSmall, borderTopEndRadius: 4, borderBottomEndRadius: 4}}>
                    {item.link ?
                      <View style={{pointerEvents: 'auto', flexDirection: 'row', justifyContent: isLTR ? 'flex-start' : 'flex-end'}}>
                        <Button
                          disableElevation={true}
                          variant={'contained'}
                          size={'small'}
                          color={'primary'}
                          elevation={false}
                          style={{marginBottom: 6, zIndex: zIndex}}
                          onClick={onPromotedLinkClicked}>
                          {linkButtonText}
                        </Button>
                      </View>
                      :
                      // isDefaultPost ?
                      //   <View style={{flexDirection: 'row'}}>
                      //     <View style={{borderWidth: 1, borderColor: ColorWhite, marginLeft: 1, padding: 6, paddingTop: 2, paddingBottom: 2, borderRadius: 4, marginBottom: title ? 8 : 0}}>
                      //       <AppText
                      //         style={{textTransform: 'uppercase', color: ColorWhite, fontSize: 10, fontWeight: FontWeightRegular}}>
                      //         {locString('sponsored')}
                      //       </AppText>
                      //     </View>
                      //   </View>
                      //   :
                      null
                    }
                    {title ?
                      <View style={{pointerEvents: 'auto', marginBottom: 8}}>
                        <ReadMoreText
                          fontSizeN={uiConfigs.fontSize}
                          variant={'body2'}
                          align={'left'}
                          text={title}
                          showCount={80}
                          style={{color: ColorWhite, fontWeight: FontWeightMedium, textShadow: textShadowStyle}}
                          aStyle={{zIndex: zIndex}}
                        />
                      </View>
                      : null
                    }
                    {item.contactEmail ?
                      <View style={{pointerEvents: 'auto', marginBottom: 8, marginTop: -4}}>
                        <TextView
                          fontSizeN={uiConfigs.fontSize}
                          variant={'body2'}
                          align={'left'}
                          style={{color: ColorWhite, fontWeight: FontWeightRegular, marginBottom: 6, textShadow: textShadowStyle}}
                          aStyle={{zIndex: zIndex}}>
                          <FormattedHTMLMessage id={'activity.contactEmail'} values={{value: item.contactEmail}}></FormattedHTMLMessage>
                        </TextView>
                      </View>
                      : null
                    }
                    {item.rating > 0 ?
                      <div style={{marginBottom: 6}}>
                        <OpinionReadOnlyRating
                          style={{fontSize: '1.8rem'}}
                          size={'large'}
                          value={item.rating}
                          readOnly
                        />
                      </div>
                      : null
                    }
                    {name || timeSince ?
                      <View style={{flexDirection: isLTR ? 'row' : 'row-reverse', alignItems: 'center'}}>
                        {name ?
                          <View style={{flex: 1, flexDirection: isLTR ? 'row' : 'row-reverse', alignItems: 'center'}}>
                            {/*<TouchableOpacity onClick={onUserClicked} disabled={item.isAnonymous}>*/}
                            <AppImage
                              style={{width: imageSize, height: imageSize, borderColor: COLOR_TEXT_BORDER, borderWidth: 1, borderStyle: 'solid', borderRadius: imageSize/2}}
                              imageUrl={userImageUrl}
                            />
                            {/*</TouchableOpacity>*/}
                            <AppText
                              fontSizeN={uiConfigs.fontSize}
                              align={'left'}
                              color={ColorWhite}
                              style={{
                                flex: 1,
                                marginLeft: isLTR ? SpaceXSmall : 0,
                                marginRight: !isLTR ? SpaceXSmall : 0,
                                fontWeight: FontWeightMedium,
                                textShadow: textShadowStyle,
                              }}>
                              {name}
                            </AppText>
                          </View>
                          : null
                        }
                        {timeSince ?
                          <AppText
                            fontSizeN={uiConfigs.fontSize}
                            variant={'caption'}
                            style={{
                              marginLeft: isLTR ? SpaceSmall : 0,
                              marginRight: !isLTR ? SpaceSmall : 0,
                              fontSize: FontSizeXSmall,
                              fontWeight: FontWeightRegular,
                              color: '#EEEEEE',
                              textShadow: textShadowStyle}}>
                            {timeSince}
                          </AppText>
                          : null
                        }
                      </View>
                      : null
                    }
                  </View>
                  {showActions ?
                    <View style={{pointerEvents: 'auto', paddingRight: isLTR ? 8 : 0, paddingLeft: !isLTR ? 8 : 0, paddingTop: 4, borderTopStartRadius: 4, borderBottomStartRadius: 4, alignItems: 'center', zIndex: zIndex}}>
                      {!isShowingMixed && (showRewardsWon || isWinningPost) ?
                        <View style={{marginBottom: iconSpaceBottom, width: iconOuterWidth, height: iconOuterWidth, borderRadius: 20 * sizeFactor, padding: 1, backgroundColor: 'rgba(255,255,255,0.95)'}}>
                          <TouchableOpacity onClick={showRewardsWon ? onRewardsWonClicked : onWinningPostClicked} style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                            <AppImage source={require('src/images/activityChallenge/11-img_rewards_won.png')} style={{width: iconOuterWidth-8, height: iconOuterWidth-8}} />
                          </TouchableOpacity>
                        </View>
                        : null
                      }

                      {/*{business ?*/}
                      {/*  <View style={{marginBottom: iconSpaceBottom, width: iconOuterWidth, height: iconOuterWidth, borderRadius: RadiusView, padding: 1, backgroundColor: 'rgba(255,255,255,0.3)'}}>*/}
                      {/*    <TouchableOpacity disabled={!business.link} onClick={onBusinessClicked} style={{flex: 1, opacity: 1}}>*/}
                      {/*      <AppImage imageUrl={business.imageUrl} style={{width: iconOuterWidth-2, height: iconOuterWidth-2, borderRadius: RadiusView}} />*/}
                      {/*    </TouchableOpacity>*/}
                      {/*  </View>*/}
                      {/*  : null*/}
                      {/*}*/}

                      {/*{canPublicAction && showWinners ?*/}
                      {/*    <View style={{marginBottom: 12, width: 42, height: 42, borderRadius: 21, backgroundColor: isWinnersSelected ? ColorAccent : ColorClear}}>*/}
                      {/*        <AppIconButton style={{opacity: 0.9}} onClick={onWinnersClicked} icon={IconCrown} color={ColorWhite} size={17}/>*/}
                      {/*    </View>*/}
                      {/*    : null*/}
                      {/*}*/}
                      {showDownload || showWinnerDownload ?
                        <AppIconButton style={{marginBottom: iconSpaceBottom, opacity: 0.9, borderRadius: iconOuterWidth/2, width: iconOuterWidth, height: iconOuterWidth, minWidth: iconOuterWidth, minHeight: iconOuterWidth}} onClick={onDownloadClicked} icon={IconDownload} color={showWinnerDownload && item.downloadCount > 0 ? '#22eb5d' : ColorWhite} sizePx={iconSizePx} bgColor={translucentColor}/>
                        : null
                      }
                      {showTrends ?
                        <AppIconButton style={{marginBottom: iconSpaceBottom, opacity: 0.9, borderRadius: iconOuterWidth/2, width: iconOuterWidth, height: iconOuterWidth, minWidth: iconOuterWidth, minHeight: iconOuterWidth}} onClick={onTrendsClicked} icon={IconTrend} color={ColorWhite} sizePx={iconSizePx} bgColor={translucentColor}/>
                        : null
                      }
                      {showViews ?
                        <View style={{marginBottom: iconTextSpaceBottom, alignItems: 'center'}}>
                          <AppIconButton disabled={true} onClick={() => {}} icon={IconView} color={ColorWhite} sizePx={iconSizePx} style={{opacity: 1, borderRadius: iconOuterWidth/2, width: iconOuterWidth, height: iconOuterWidth, minWidth: iconOuterWidth, minHeight: iconOuterWidth}} bgColor={translucentColor}/>
                          <AppText fontSizeN={uiConfigs.fontSize} variant={'body1'} style={{fontWeight: FontWeightMedium, color: ColorWhite, textAlign: 'center', borderRadius: 5, textShadow: textShadowStyle}}>{viewsCount}</AppText>
                        </View>
                        : null
                      }
                      {showLikes ?
                        <View style={{marginBottom: iconTextSpaceBottom, alignItems: 'center'}}>
                          <AppIconButton disabled={disableLike} onClick={onLikeClicked} icon={likeIcon} color={ColorWhite} sizePx={iconSizePx} style={{borderRadius: iconOuterWidth/2, width: iconOuterWidth, height: iconOuterWidth, minWidth: iconOuterWidth, minHeight: iconOuterWidth}} bgColor={translucentColor}/>
                          <AppText fontSizeN={uiConfigs.fontSize} variant={'body1'} style={{fontWeight: FontWeightMedium, color: ColorWhite, textAlign: 'center', borderRadius: 5, textShadow: textShadowStyle}}>{likesCount}</AppText>
                        </View>
                        : null
                      }
                      {canShare && !inPreview ?
                        <AppIconButton style={{marginBottom: iconSpaceBottom, opacity: 0.9, borderRadius: iconOuterWidth/2, width: iconOuterWidth, height: iconOuterWidth, minWidth: iconOuterWidth, minHeight: iconOuterWidth}} onClick={onShareClicked} icon={IconPaperPlane} color={ColorWhite} sizePx={iconSizePx} bgColor={translucentColor}/>
                        : null
                      }
                      {showRewards ?
                        <AppIconButton style={{marginBottom: iconSpaceBottom, opacity: 0.9, borderRadius: iconOuterWidth/2, width: iconOuterWidth, height: iconOuterWidth, minWidth: iconOuterWidth, minHeight: iconOuterWidth}} onClick={onRewardsClicked} icon={IconTrophy} color={ColorWhite} sizePx={iconSizePx} bgColor={translucentColor}/>
                        : null
                      }
                      <AppIconButton style={{marginBottom: iconSpaceBottom, opacity: 0.9, borderRadius: iconOuterWidth/2, width: iconOuterWidth, height: iconOuterWidth, minWidth: iconOuterWidth, minHeight: iconOuterWidth}} onClick={onMoreClicked} icon={IconDotsV} color={ColorWhite} sizePx={iconSizePx} bgColor={translucentColor}/>
                      {sponsorFrontData ?
                        <View style={{marginBottom: 8, width: iconOuterWidth, height: iconOuterWidth, borderRadius: RadiusView, padding: 1, backgroundColor: 'rgba(255,255,255,0.3)'}}>
                          <TouchableOpacity onClick={onBusinessClicked} style={{flex: 1, opacity: 1}}>
                            <AppImage imageUrl={sponsorFrontData.imageUrl} style={{width: iconOuterWidth-2, height: iconOuterWidth-2, borderRadius: RadiusView}} />
                          </TouchableOpacity>
                        </View>
                        : null
                      }
                    </View>
                    : null
                  }
                  {showActions1 ?
                    <View style={{pointerEvents: 'auto', paddingRight: isLTR ? 8 : 0, paddingLeft: !isLTR ? 8 : 0, paddingTop: 4, borderTopStartRadius: 4, borderBottomStartRadius: 4, alignItems: 'center', zIndex: zIndex}}>
                      {showDownload ?
                        <AppIconButton style={{marginBottom: 48, opacity: 0.9, borderRadius: iconOuterWidth/2, width: iconOuterWidth, height: iconOuterWidth, minWidth: iconOuterWidth, minHeight: iconOuterWidth}} onClick={onDownloadClicked} icon={IconDownload} color={showWinnerDownload && item.downloadCount > 0 ? '#22eb5d' : ColorWhite} sizePx={iconSizePx} bgColor={translucentColor}/>
                        : null
                      }
                    </View>
                    : null
                  }
                </View>
                {showAddPost || showCampaign ?
                  <View style={{pointerEvents: 'auto', padding: SpaceXSmall, paddingTOp: SpaceXSmall, backgroundColor: translucentColor, borderTopWidth: 1, borderColor: 'rgba(255,255,255,.1)'}}>
                    <View style={{flexDirection: isLTR ? 'row' : 'row-reverse', alignItems: 'center', justifyContent: 'end'}}>
                      {showCampaign ?
                        <View style={{flex: 1, flexDirection: isLTR ? 'row' : 'row-reverse', borderWidth: 1, borderColor: isInSameTrend ? AppUtils.colorWithAlpha(ColorWhite, 0.7) : AppUtils.colorWithAlpha(ColorWhite, 0.9), borderRadius: HeightElementMinimum/2, padding: 4}}>
                          <TouchableOpacity onClick={onActivityClicked} style={{opacity: 1, zIndex: zIndex, display: 'flex', flexDirection: isLTR ? 'row' : 'row-reverse'}}>
                            <View
                              style={{
                                minHeight: 24,
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                flexDirection: isLTR ? 'row' : 'row-reverse',
                                marginRight: isLTR ? 4 : 0,
                                marginLeft: !isLTR ? 4 : 0}}>
                              <ImageIcon src={require('src/images/ic_reels.png')} width={isInSameTrend ? 20 : 24} height={'auto'} style={{opacity: isInSameTrend ? 0.8 : 1}} />
                              <AppText
                                fontSizeN={uiConfigs.fontSize}
                                variant={isInSameTrend ? 'body2' : 'body1'}
                                numberOfLines={isInSameTrend ? 1 : 1}
                                align={'left'}
                                style={{
                                  marginLeft: isLTR ? 8 : 16,
                                  marginRight: isLTR ? 16 : 8,
                                  fontSize: FontSizeSmall,
                                  fontWeight: isInSameTrend ? FontWeightRegular : FontWeightMedium,
                                  color: isInSameTrend ? AppUtils.colorWithAlpha(ColorWhite, 0.8) : ColorWhite,
                                }}>
                                {item.activity.title}
                              </AppText>
                              {!isInSameTrend ? <ImageIcon src={require('src/images/ic_open_out.png')} style={{width: 20, height: 20}} /> : null}
                              <div className={classes.flexGrow}/>
                            </View>
                          </TouchableOpacity>
                          <View style={{height: 1}} />
                        </View>
                        : null
                      }
                      {showAddPost ?
                        <View style={{marginLeft: isLTR ? 20 : 0, marginRight: !isLTR ? 20 : 0, zIndex: zIndex}}>
                          <TouchableOpacity onClick={onAddPostClicked}>
                            <View style={{width: Math.max(80 * sizeFactor, 88), height: Math.max(38 * sizeFactor, 44), borderRadius: Math.max(19 * sizeFactor, 22), backgroundColor: 'rgba(255,255,255,.5)'}}>
                              <View style={{flex: 1, borderRadius: Math.max(19 * sizeFactor, 22), marginRight: 8, backgroundColor: 'rgba(255,255,255,.7)'}}>
                                <View style={{flex: 1, borderRadius: Math.max(19 * sizeFactor, 22), marginLeft: 8, backgroundColor: ColorWhite, alignItems: 'center', justifyContent: 'center'}}>
                                  <AppIcon icon={IconAdd} color={ColorBlack} size={iconSize} />
                                </View>
                              </View>
                            </View>
                          </TouchableOpacity>
                        </View>
                        : null
                      }
                    </View>
                  </View>
                  : null
                }
              </View>
            </View>
            : null
          }

          {backData ?
            <div style={{position: 'absolute', top: isXS ? 4 : 8, ...isLTR ? {left: 6} : {right: 6}}}>
              <View style={{display: 'flex', flexDirection: isLTR ? 'row' : 'row-reverse', alignItems: 'center'}}>
                {!hideBack ?
                  <React.Fragment>
                    <div style={{borderRadius: 22, backgroundColor: translucentColor, width: 44, height: 44, zIndex: zIndex}}>
                      <NavBackActionView color={ColorWhite} isLTR={isLTR} onClick={props.onBackClicked}/>
                    </div>
                    <Space vertical={16}/>
                  </React.Fragment>
                  : null
                }
                <TouchableOpacity disabled={!backData.imageUrl} onClick={onBusinessClicked} style={{opacity: 1, zIndex: zIndex, display: 'flex', flexDirection: isLTR ? 'row' : 'row-reverse', alignItems: 'center'}}>
                  {backData.imageUrl ?
                    <AppImage imageUrl={backData.imageUrl} style={{width: 36*sizeFactor, height: 36*sizeFactor, borderRadius: RadiusView, borderWidth: '1px solid '+ ColorBorder}} />
                    : null
                  }
                  <AppText
                    fontSizeN={uiConfigs.fontSize}
                    variant={'body1'}
                    align={'left'}
                    color={ColorWhite}
                    numberOfLines={1}
                    style={{
                      marginLeft: SpaceXSmall,
                      marginRight: SpaceXSmall,
                      fontWeight: FontWeightMedium,
                      textShadow: textShadowStyle,
                    }}>
                    {backData.name}
                  </AppText>
                </TouchableOpacity>
                <Space vertical={8}/>
              </View>
            </div>
            : null
          }

          {showSwipeUp.current ?
            <animated.div
              style={{pointerEvents: 'none', position: 'absolute', left: 60, right: 60, bottom: swipeUpBottom, display: 'flex', flexDirection: 'column', alignItems: 'center',
                // transform: [{
                //   translateY: this.state.animatedY
                // }]
            }}>
              {showSwipeUp.current > 1 ?
                <View style={{backgroundColor: 'rgba(255,255,255,0.8)', borderRadius: 18 * sizeFactor, width: 36 * sizeFactor, height: 36 * sizeFactor, alignItems: 'center', justifyContent: 'center'}}>
                  <AppIcon icon={showSwipeUp.current > 1 ? IconArrowUpLong : IconAdd} color={ColorBlack} size={iconSize} />
                </View>
                : null
              }
              <AppText fontSizeN={uiConfigs.fontSize} variant={'body1'} style={{borderRadius: 20, alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,0.8)', padding: 4 * sizeFactor, paddingLeft: 16, paddingRight: 16, marginTop: 12, color: ColorBlack, fontWeight: FontWeightRegular}}>{locString(showSwipeUp.current > 1 ? 'activity.swipeUpForMore' : 'activity.addYourPost')}</AppText>
            </animated.div>
            : null
          }
        </View>
      </Paper>
    </div>
  );
}));

const GetViewForItemWrapper = React.memo((props) => {

  const onRef = (ref) => {
    props.onRef(props.index, ref);
  };

  return <GetViewForItem ref={onRef} {...props}/>
});

const GetViewForLoader = React.memo((props) => {
  const {isXS, width, height, uiConfigs, classes} = props;
  const itemHeight = isXS ? height : height - 16;
  const itemWidth = isXS ? width : itemHeight/16*9;
  const borderRadius = isXS ? 0 : BORDER_RADIUS;
  return (
    <div key={props.key} style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <Paper elevation={isXS ? 0 : 1} className={classes.cardItemWrapper} style={{borderRadius: borderRadius, width: itemWidth, height: itemHeight, marginTop: isXS ? 0 : 16, marginBottom: isXS ? 0 : 16, backgroundColor: ColorBlack, position: 'relative'}}>
        <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
          <CircularProgress size={uiConfigs.fontSize * 2} style={{color: ColorWhite}}/>
        </View>
      </Paper>
    </div>
  );
});

const GetViewForError = React.memo((props) => {
  const {isXS, width, height, uiConfigs, classes, error, onRetryClicked} = props;
  const itemHeight = isXS ? height : height - 16;
  const itemWidth = isXS ? width : itemHeight/16*9;
  const borderRadius = isXS ? 0 : BORDER_RADIUS;

  return (
    <div key={props.key} style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <Paper elevation={isXS ? 0 : 1} className={classes.cardItemWrapper} style={{borderRadius: borderRadius, width: itemWidth, height: itemHeight, marginTop: isXS ? 0 : 16, marginBottom: isXS ? 0 : 16, backgroundColor: ColorBlack, position: 'relative'}}>
        <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
          <div className={classes.messageBox}>
            <TextView fontSizeN={uiConfigs.fontSize} align={'center'} variant="h6" color={ColorWhite}>
              {error}
            </TextView>
            <LinkButton
              style={{marginTop: FIELD_SPACE}}
              // size={'small'}
              variant={'outlined'}
              // color={"primary"}
              onClick={onRetryClicked}>
              {<FormattedMessage id={'retry'} />}
            </LinkButton>
          </div>
        </View>
      </Paper>
    </div>
  );
});

const MenuView = React.memo((props) => {
  const {classes, uiConfigs, showMenu, showMenuElement, hideLanguage, hideReport, hideDelete, inPreview, item, showWinners, isCreatedByMe, showSponsor} = props;

  let canPublicAction = true;
  let isWin = false;
  if (item.isDummy) {
    canPublicAction = false;
  } else if (item.activity && item.activity.type === constants.activity.types.SOCIAL_CONTENT) {
    canPublicAction = false;
    isWin = item.downloadCount > 0;
  }

  const onCloseMore = () => {
    props.onCloseMore();
  };
  const onMoreDetailsClicked = () => {
    onCloseMore();
    props.onMoreDetailsClicked(item);
  };
  const onWinnersClicked = () => {
    onCloseMore();
    props.onWinnersClicked(item);
  };
  const onDeleteClicked = () => {
    onCloseMore();
    props.onDeleteClicked(item);
  };
  const onReportClicked = () => {
    onCloseMore();
    props.onReportClicked(item);
  };
  const onSponsorClicked = () => {
    onCloseMore();
    props.onSponsorClicked(item);
  };

  return (
    <Menu
      id="menu"
      anchorEl={showMenuElement}
      getContentAnchorEl={null}
      anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
      transformOrigin={{vertical: 'top', horizontal: 'center'}}
      open={showMenu}
      onClose={onCloseMore}>
      <MenuItem dense onClick={onMoreDetailsClicked}>
        <div className={classes.menuItemBox}>
          <TextView color={ColorTitle} variant={'body2'}>
            <FormattedMessage id='moreDetails' />
          </TextView>
        </div>
      </MenuItem>
      {showWinners ?
        <MenuItem dense onClick={onWinnersClicked}>
          <div className={classes.menuItemBox}>
            <TextView color={ColorTitle} variant={'body2'}>
              <FormattedMessage id='winners' />
            </TextView>
          </div>
        </MenuItem>
        : null
      }
      {showSponsor ?
        <MenuItem dense onClick={onSponsorClicked}>
          <div className={classes.menuItemBox}>
            <TextView color={ColorTitle} variant={'body2'}>
              <FormattedMessage id='activity.sponsor' />
            </TextView>
          </div>
        </MenuItem>
        : null
      }

      {!hideDelete && isCreatedByMe && !isWin && !inPreview ?
        <MenuItem dense onClick={onDeleteClicked}>
          <div className={classes.menuItemBox}>
            <TextView color={ColorNegative} variant={'body2'}>
              <FormattedMessage id='delete' />
            </TextView>
          </div>
        </MenuItem>
        : null
      }
      {/*{!item.isDefaultPost && !isCreatedByMe && canPublicAction ?*/}
      {!hideReport && !isCreatedByMe && !inPreview ?
        <MenuItem dense onClick={onReportClicked}>
          <div className={classes.menuItemBox}>
            <TextView variant={'body2'} color={ColorTitle}>
              <FormattedMessage id='report' />
            </TextView>
          </div>
        </MenuItem>
        : null
      }
      {!hideLanguage ?
        <GetLanguageSelectorView uiConfigs={uiConfigs} />
        : null
      }
    </Menu>
  );
});

// const GetSliderView = React.memo((props) => {
//   const {slidesCount, currentIndex, slideRenderer, onChangeIndex, onTransitionEnd} = props;
//   return (
//     <VirtualizeSwipeableViews
//       style={{height: '100%', width: '100%'}}
//       containerStyle={{height: '100%', width: '100%'}}
//       enableMouseEvents={true}
//       ignoreNativeScroll={true}
//       slideCount={slidesCount}
//       axis={'y'}
//       index={currentIndex}
//       slideRenderer={slideRenderer}
//       onChangeIndex={onChangeIndex}
//       onTransitionEnd={onTransitionEnd}/>
//   );
// });

class ActivityReelsView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.slidesDisplayed = new Set();
    this.wasPlaying = false;

    this.state = {
      reels: this.getDefaultReels(),
      isFetching: false,
      reload: false,
      currentIndex: 0,
      likesApiInProgress: new Set(),
      isBlockedLoading: false,
      loadingProgress: 0,
    };
    this.swipeUpIndex = 0;
    this.refItems = {};
    this.previewedActivityPostIds = new Set();
  }

  getDefaultReels() {
    if (this.props.inPreview && this.props.previewPaginated) {
      return this.props.previewPaginated;
    }
    return {
      data: [],
      page: 1,
    };
  }

  componentDidMount() {
    this.props.playPauseCallback(this);
    this.fetchData();
  }

  componentWillUnmount() {
    this.stopDownloadInterval();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.inPreview && nextProps.previewPaginated /* && nextProps.previewPaginated !== prevState.reels*/) {
      return ({reels: nextProps.previewPaginated});
    }
    return null;
  }

  onAppDidFocus = () => {
    if (this.wasPlaying) {
      this.playItem(this.state.currentIndex);
    }
  };

  onAppDidBlur = () => {
    this.wasPlaying = this.isItemPlaying(this.state.currentIndex);
    this.pauseItem(this.state.currentIndex);
  };

  // shouldComponentUpdate(nextProps, nextState, nextContext) {
  //   ViewHelper.logStatePropsChange(this.state, nextState, this.props, nextProps, 'LD');
  //   return true;
  // }

  render() {
    const {classes, isXS, isDrawerHidden, isLTR, windowWidth, windowHeight} = this.props;
    const {isFetching, error, currentIndex, reels, isBlockedLoading, loadingProgress} = this.state;

    const showData = reels.data.length > 0;
    let showRetry = false;
    let message = null;
    if (reels.data.length === 0) {
      if (error) {
        message = error;
        showRetry = true;
      } else if (!isFetching) {
        message = this.context.intl.formatMessage({id: this.getNoItemsMessageId()});
      }
    }
    const slidesCount = reels.data.length + (reels.canLoadMore && error ? 1 : 0);
    const showMessage = reels.data.length === 0 && message !== null;
    const showLoader = reels.data.length === 0 && isFetching;

    const viewHeight = this.props.inPreview ? this.props.height : windowHeight;
    return (
      <div className={classes.viewWrapper} style={{width: '100%', height: viewHeight, justifyContent: showMessage ? 'flex-start' : 'center'}}>
        <FocusHelperView
          onAppDidFocus={this.onAppDidFocus}
          onAppDidBlur={this.onAppDidBlur}
        />
        {showLoader ?
          <div className={classes.viewLoadingInside}>
            <CircularProgress />
          </div>
          : null
        }
        {showMessage ?
          <div className={classes.containerError} style={{alignSelf: 'flex-start'}}>
            <Typography align={'center'} variant="subtitle1" color={'textSecondary'} className={classes.typoMedium}>
              {message}
            </Typography>

            <div className={classes.viewRow}>
              <Button
                disableElevation={true}
                style={{marginTop: FIELD_SPACE}}
                size={isXS ? 'small' : 'medium'}
                variant={'outlined'}
                color={"secondary"}
                onClick={this.props.onBackClicked}>
                {<FormattedMessage id={'back'} />}
              </Button>
              {showRetry ?
                <React.Fragment>
                  <Space verticalSpace={2} />
                  <Button
                    disableElevation={true}
                    style={{marginTop: FIELD_SPACE}}
                    size={isXS ? 'small' : 'medium'}
                    variant={'contained'}
                    color={"primary"}
                    onClick={this.onRetryClicked}>
                    {<FormattedMessage id={'retry'} />}
                  </Button>
                </React.Fragment>
                : null
              }
            </div>
          </div>
          : null
        }
        {showData ?
          <VirtualizeSwipeableViews
            key={this.props.height +'-'+ this.state.dataChange}
            style={{height: '100%', width: '100%'}}
            containerStyle={{height: '100%', width: '100%'}}
            enableMouseEvents={true}
            ignoreNativeScroll={true}
            slideCount={slidesCount}
            axis={'y'}
            index={currentIndex}
            slideRenderer={this.getSlideView}
            onChangeIndex={this.onChangeIndex}
            onTransitionEnd={this.onTransitionEnd}/>
          : null
        }
        {showMessage && !this.props.inPreview && isDrawerHidden ?
          <div style={{position: 'absolute', top: 0, height: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, width: 60, display: 'flex', alignItems: 'center', ...isLTR ? {left: 0} : {right: 0}}}>
            <NavBackActionView isLTR={isLTR} onClick={this.props.onBackClicked}/>
          </div>
          : null
        }
        {this.renderMenu()}
        {this.renderDialogView()}
        {this.renderSnackBar()}
        {isBlockedLoading && <ProgressLoader progress={loadingProgress} />}
      </div>
    );
  }

  renderMenu() {
    const {classes, uiConfigs, userId, activity, inPreview} = this.props;
    const userMeType = 1;
    const showMenu = this.state.showMenuItem != null;
    if (!showMenu) {
      return null;
    }
    const item = this.state.showMenuItem;
    let effActivity = activity;
    if (!effActivity) {
      effActivity = item.activity;
    }
    let showWinners = false;
    if (effActivity) {
      showWinners = effActivity.showWinners;
    }
    return (
      <MenuView
        classes={classes}
        uiConfigs={uiConfigs}
        showMenu={showMenu}
        showMenuElement={showMenu ? this.state.showMenuElement : null}
        inPreview={inPreview}
        item={item}
        showWinners={showWinners}
        showSponsor={true}
        isCreatedByMe={item.id > 0 && item.createdById === userId && item.createdByType === userMeType}
        onCloseMore={this.onCloseMore}
        hideLanguage={this.props.playInShowcase || this.props.inPreview}
        hideReport={this.props.playInShowcase || this.props.inPreview}
        hideDelete={this.props.playInShowcase || this.props.inPreview}
        onMoreDetailsClicked={this.onMoreDetailsClicked}
        onSponsorClicked={this.onSponsorClicked}
        onWinnersClicked={this.onWinnersClicked}
        onReportClicked={this.onReportClicked}
        onDeleteClicked={this.onDeleteClicked}
      />
    );
  }

  getNoItemsMessageId() {
    return 'activity.noPosts';
  }

  onMoreDetailsClicked = (item) => {
    this.props.onMoreDetailsClicked(this.getEffActivity(item));
  }

  onSponsorClicked = (item) => {
    this.props.onSponsorClicked(item);
  }

  onWinnersClicked = (item) => {
    this.props.onWinnersClicked(this.getEffActivity(item));
  }

  renderDialogView() {
    const {classes} = this.props;
    const {showDialog, dialogInfo} = this.state;
    if (!showDialog) {
      return null;
    }

    const {
      title,
      message,
      content,
      positiveText,
      onPositiveClicked,
      neutralText,
      onNeutralClicked,
    } = dialogInfo;
    return (
      <DialogView
        classes={classes}
        show={showDialog}
        title={title}
        message={message}
        content={content}
        positiveText={positiveText}
        onPositiveClicked={onPositiveClicked}
        neutralText={neutralText}
        onNeutralClicked={onNeutralClicked}
      />
    );
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      this.setState({showDialog: true, dialogInfo: dialogInfo});
    }
  }

  hideDialog = () => {
    this.setState({showDialog: false, dialogInfo: null});
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      return (
        <Snackbar open={snackbarMessageId || snackbarMessage} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={this.onCloseSnackbar}>
          <MuiAlert severity={snackbarType || "success"} onClose={this.onCloseSnackbar} elevation={6} variant="filled" style={{borderRadius: BORDER_RADIUS}}>
            {snackbarMessageId ? <FormattedMessage id={snackbarMessageId}/> : null}
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  onCloseSnackbar = () => {
    this.setState({showSnackbar: false, snackbarInfo: null});
  }

  getSlideView = ({key, index}) => {
    this.slidesDisplayed.add(index);
    const {classes, isLTR, isXS, uiConfigs, width, height, userId, userBId, activity, inPreview} = this.props;
    const {isFetching, error, reels} = this.state;
    const userMeType = 1;
    const viewHeight = this.props.inPreview ? this.props.height : this.props.windowHeight;

    if (index === reels.data.length && reels.canLoadMore && error) {
      return <GetViewForError
        key={key}
        isXS={isXS}
        width={width}
        height={height}
        uiConfigs={uiConfigs}
        classes={classes}
        error={error}
        onRetryClicked={this.onRetryClicked} />
    }
    else if (index === reels.data.length && reels.canLoadMore && isFetching) {
      return <GetViewForLoader
        key={key}
        isXS={isXS}
        width={width}
        height={height}
        uiConfigs={uiConfigs}
        classes={classes} />
    }
    else if (index < reels.data.length /* && index >= currentIndex - 4 && index <= currentIndex + 4 */) {
      const item = reels.data[index];

      const effActivity = this.getEffActivity(item);
      let canMakeAction = false;
      let showWinners = false;
      const showRewardsWon = item.downloadCount > 0 && item.createdById === userId && item.createdByType === userMeType;
      let showRewards = false;
      const isInSameTrend = activity && item.activity && activity.id === item.activity.id;
      if (effActivity) {
        canMakeAction = DateTimeHelper.getSecondsDiffFromNow(effActivity.endAt) > 0;
        showWinners = effActivity.showWinners;
        showRewards = effActivity.hasRewards || this.props.inPreview;
      }
      const isCreatedByMe = item.id > 0 && item.createdById === userId && item.createdByType === userMeType;
      const baseCanDownload = !inPreview && item.id > 0 && ((item.imageUrls && item.imageUrls.length > 0) || item.videoStreamUrl || item.audioUrl);
      const showWinnerDownload = baseCanDownload && !isCreatedByMe && userBId === item.businessId && !item.isDefaultPost
        && (item.activity.type === constants.activity.types.CHALLENGE || item.activity.type === constants.activity.types.SOCIAL_CONTENT);
      const showDownload = baseCanDownload && !showWinnerDownload;
      return (
        <GetViewForItemWrapper
          onRef={this.onRef}
          key={key +'-'+ item.id}
          onNextVideoTouchStart={this.onNextVideoTouchStart}
          onNextVideoClick={this.onNextVideoClick}
          index={index}
          showSwipeUp={!inPreview && index === this.swipeUpIndex ? reels.data.length - (this.props.postId ? 1 : 0) : 0}
          inPreview={this.props.inPreview}
          ctaTitles={this.props.ctaTitles}
          uiConfigs={uiConfigs}
          width={width}
          height={height}
          maxHeight={viewHeight}
          isXS={isXS}
          classes={classes}
          isLTR={isLTR}
          item={item}
          itemId={item.id}
          itemLike={item.like}
          isAd={false}
          sponsorFrontData={activity.myReels || item.isDefaultPost ? item.business : null}
          hideBack={this.props.hideActions || this.props.inPreview}
          backData={!this.props.hideTop ? (activity.myReels ? activity.business : effActivity.business) : null}
          // maxHeight={this.error && this.items.indexOf(item) === this.items.length - 1 ? this.props.height - this.loadMoreErrorViewHeight : this.props.height}
          isCreatedByMe={isCreatedByMe}
          isShowingMixed={false}
          hideActions={this.props.hideActions}
          showShare={!this.props.playInShowcase && !this.props.inPreview}
          showCampaign={!this.props.hideActions && item.activity && item.activity.type === constants.activity.types.CHALLENGE}
          showAddPost={!this.props.playInShowcase && !this.props.hideActions && canMakeAction}
          showWinners={!this.props.hideActions && showWinners}
          showRewardsWon={!this.props.playInShowcase && !this.props.hideActions && showRewardsWon}
          showRewards={!this.props.hideActions && showRewards}
          isWinningPost={false}
          isWinnersSelected={false}
          isInSameTrend={isInSameTrend}
          showWinnerDownload={!this.props.playInShowcase && showWinnerDownload}
          showDownload={!this.props.playInShowcase && showDownload}
          showTrends={false}
          disableLike={this.state.likesApiInProgress.has(item.id)}
          onPress={this.onItemClicked}
          // onUserClicked={this.onUserClicked}
          onMoreClicked={this.onMoreClicked}
          onLikeClicked={this.onLikeClicked}
          // onCommentsClicked={this.onCommentsClicked}
          // onDislikePressed={this.onDislikePressed}
          onShareClicked={this.onShareClicked}
          onActivityClicked={this.onActivityClicked}
          // onVideoPlayClicked={this.onVideoPlayClicked}
          // onVideoEnded={this.onVideoEnded}
          onBackClicked={this.props.onBackClicked}
          onAddPostClicked={this.onAddPostClicked}
          onBusinessClicked={this.props.onBusinessClicked}
          onRewardsClicked={this.onRewardsClicked}
          onRewardsWonClicked={this.onRewardsWonClicked}
          onWinningPostClicked={this.onWinningPostClicked}
          onWinnersClicked={this.onWinnersClicked}
          onTrendsClicked={this.onTrendsClicked}
          onDownloadClicked={this.onDownloadClicked}
          onPromotedLinkClicked={this.props.onPromotedLinkClicked}
        />
      );
    } else {
      return <div key={key} style={{height: 0}} />
    }
  }

  onTransitionEnd = () => {
    this.playItem(this.state.currentIndex);
    logDebug('slidesDisplayed', this.slidesDisplayed);
    this.slidesDisplayed.clear();
  }

  onChangeIndex = (index, indexLatest, meta) => {
    if (this.props.noActionMode || this.props.isGuestUser) {
      let blockAfter = this.props.isGuestUser ? Math.max(0, this.state.reels.data.length -2) : this.props.postId ? 1 : 0;
      if (index > blockAfter) {
        if (this.props.noActionMode) {
          if (this.props.onActionClickedInNoActionMode) {
            this.props.onActionClickedInNoActionMode();
          }
        } else {
          // this.showDialog({
          //   title: locString('activity.joinRab7ForFurther'),
          //   message: locString('activity.joinRab7ToViewAllPosts'),
          //   onPositiveClicked: () => {
          //     this.hideDialog();
          //     setTimeout(() => {
          //       this.props.onJoinRab7Clicked(this.props.activity);
          //     }, 100);
          //   },
          //   positiveText: locString('login.joinRab7Short'),
          //   neutralText: locString('generic.later'),
          //   onNeutralClicked: this.hideDialog,
          // });
          this.props.onJoinRab7Clicked(this.props.activity, locString('login.joinRab7Short'), locString('activity.joinRab7ToViewAllPosts'));
        }

        const currentIndex = this.state.currentIndex;
        this.setState({currentIndex: index}, () => {
          this.setState({currentIndex: currentIndex});
        });
        return;
      }
    }

    if (index === 0) {
      this.swipeUpIndex = 0;
    }
    this.setState({currentIndex: index});

    const {isFetching, reels} = this.state;

    if (reels.canLoadMore && !isFetching && index >= reels.data.length - LOAD_MORE_BEFORE) {
      this.fetchData(reels.page + 1);
    }
    this.processItemPlayPause(index, indexLatest);
  }

  processItemPlayPause = (index, indexLatest, hasInteraction = true) => {
    this.stopItem(indexLatest);
    this.playItem(index, hasInteraction);

    if (!this.props.noActionMode) {
      setTimeout(() => {
        const paginated = this.state.reels;
        if (index < paginated.data.length) {
          const item = paginated.data[index];
          if (item.feedType === FEED_TYPE_POST && item.type === POST_TYPE_CHALLENGE && item.id > 0) {
            if (!this.previewedActivityPostIds.has(item.id)) {
              this.previewedActivityPostIds.add(item.id);
              setTimeout(() => {
                this.props.markActivityPostPreviewed(item.id, this.props.showcaseId).catch(() => {
                  this.previewedActivityPostIds.delete(item.id);
                });
              }, 200);
            }
          }
        }
      }, 500);
    }
  }

  isItemPlaying = (index) => {
    if (this.refItems[index]) {
      return this.refItems[index].isInPlay();
    }
    return false;
  }

  pauseItem = (index) => {
    if (this.refItems[index]) {
      this.refItems[index].pause();
    }
  }

  stopItem = (index) => {
    if (this.refItems[index]) {
      this.refItems[index].stop();
    }
  }

  playItem = (index, hasInteraction = true) => {
    if (this.refItems[index]) {
      this.refItems[index].play(hasInteraction);
    }
  }

  onNextVideoTouchStart = (nextCount) => {
    logDebug('videoPlayer0-onNextVideoTouchStart');
    for (let i = -nextCount; i <= nextCount; i++) {
      if (i !== 0 && this.refItems[this.state.currentIndex + i]) {
        this.refItems[this.state.currentIndex + i].setHasInteraction();
      }
    }
  };

  onNextVideoClick = () => {
    logDebug('videoPlayer0-onNextVideoClick');
    if (this.refItems[this.state.currentIndex]) {
      this.refItems[this.state.currentIndex].onClicked();
    }
  };

  showRewardsAtLaunch() {
    const {activity} = this.props;
    // show rewards first time
    if (activity && activity.userDisplayedCount < 1 && activity.showRewards && activity.hasRewards) {
      this.rewardsAtlaunchTimer = setTimeout(() => {
        this.onRewardsClicked();
      }, activity.showRewardsAfter);
    }
  }

  onRetryClicked = () => {
    const paginated = this.state.reels;
    this.fetchData(paginated.canLoadMore ? paginated.page + 1 : 1);
  };

  onRef = (index, ref) => {
    this.refItems[index] = ref;
  }

  onMoreClicked = (item, index, target) => {
    this.setState({showMenuItem: item, showMenuElement: target});
  };

  onCloseMore = () => {
    this.setState({showMenuItem: null, showMenuElement: null});
  };

  onLikeClicked = (item, index) => {
    if (this.props.noActionMode) {
      if (this.props.onActionClickedInNoActionMode) {
        this.props.onActionClickedInNoActionMode();
      }
      return;
    }
    if (this.props.inPreview) {
      return;
    }

    let like = 1;
    if (item.like == like) {
      like = 0;
    }
    const likesApiInProgress = this.state.likesApiInProgress;
    likesApiInProgress.add(item.id);
    this.setState({likesApiInProgress: likesApiInProgress});

    const data = {
      id: item.id,
      reviewId: item.id,
      like: like
    };
    this.props.likeActivityPost(data).then(({data}) => {
      const likesApiInProgress = this.state.likesApiInProgress;
      likesApiInProgress.delete(item.id);
      const reels = this.state.reels;
      const index = reels.data.indexOf(item);
      if (index !== -1) {
        item.like = data.like;
        item.likesCount = data.likesCount;
        item.dislikesCount = data.dislikesCount;
        reels.data.splice(index, 1, item);
      }
      this.setState({reels: reels, reload: !this.state.reload, likesApiInProgress: likesApiInProgress});
    }).catch(({data}) => {
      const likesApiInProgress = this.state.likesApiInProgress;
      likesApiInProgress.delete(item.id);
      this.setState({likesApiInProgress: likesApiInProgress});
      let error = null;
      if (data && data.error) {
        error = data.error;
      } else {
        error = this.context.intl.formatMessage({id: 'generic.server_error_msg'});
      }
      this.showSnackbar({snackbarMessage: error, snackbarType: "error"});
    });
  };

  onShareClicked = (item, index) => {
    if (this.props.noActionMode) {
      if (this.props.onActionClickedInNoActionMode) {
        this.props.onActionClickedInNoActionMode();
      }
      return;
    }

    if (item) {
      this.props.onShareClicked(this.getEffActivity(item), this.props.inPreview ? 0 : item.id);
    }
  };

  onDeleteClicked = (item) => {
    if (this.props.noActionMode) {
      if (this.props.onActionClickedInNoActionMode) {
        this.props.onActionClickedInNoActionMode();
      }
      return;
    }

    const onDelete = () => {
      this.hideDialog();

      let {reels, currentIndex} = this.state;
      this.pauseItem(currentIndex);

      this.props.deleteActivityPost(item.id).then(() => {
        const indexOf = reels.data.indexOf(item);
        if (indexOf !== -1) {

          const isLast = currentIndex === reels.data.length - 1;
          if (isLast) {
            currentIndex--;
          }
          reels.data.splice(indexOf, 1);
          this.setState({reels: reels, reload: !this.state.reload, currentIndex: currentIndex}, () => {
            if (!isLast) {
              this.playItem(currentIndex);
            }

            this.showSnackbar({snackbarMessage: this.context.intl.formatMessage({id: 'postDeleted'}), snackbarType: "success"});
          });
        }
      }).catch((response) => {
        this.playItem(this.state.currentIndex);

        let error = null;
        if (response.data && response.data.error) {
          error = response.data.error;
        } else {
          error = this.context.intl.formatMessage({id: 'generic.server_error_msg'});
        }
        this.showDialog({
          title: error,
          positiveText: this.context.intl.formatMessage({id: 'generic.ok'}),
          onPositiveClicked: this.hideDialog,
        });
      });
    }
    const dialogInfo = {
      title: this.context.intl.formatMessage({id: 'deletePost'}),
      message: this.context.intl.formatMessage({id: 'deletePostPromptMessage'}),
      positiveText: this.context.intl.formatMessage({id: 'deletePost'}),
      onPositiveClicked: onDelete,
      neutralText: this.context.intl.formatMessage({id: 'generic.cancel'}),
      onNeutralClicked: this.hideDialog,
    };
    this.showDialog(dialogInfo);
  };

  onReportClicked = (item) => {
    if (this.props.noActionMode) {
      if (this.props.onActionClickedInNoActionMode) {
        this.props.onActionClickedInNoActionMode();
      }
      return;
    }

    this.props.onReportClicked(this.getEffActivity(item), item.id);
  };

  onRewardsClicked = (item) => {
    const activity = this.getEffActivity(item);
    if (!activity.withDetails) {
      this.fetchActivity(activity.id, (activity) => {
        item.activity = activity;
        this.onRewardsClicked(item);
      });
      return;
    }
    this.props.onRewardsClicked(this.getEffActivity(item));
  };

  onRewardsWonClicked = (item) => {
    const activity = this.getEffActivity(item);
    if (!activity.withDetails) {
      this.fetchActivity(activity.id, (activity) => {
        item.activity = activity;
        this.onRewardsWonClicked(item);
      });
      return;
    }

    this.props.onRewardsWonClicked(this.getEffActivity(item));
  };

  onActivityClicked = (item, index) => {
    const {activity} = this.props;
    if (activity && item.activity && activity.id === item.activity.id) {
      if (index !== 0) {
        const latestIndex = this.state.currentIndex;
        this.setState({currentIndex: 0}, () => {
          this.processItemPlayPause(0, latestIndex);
        });
      }
      return;
    }

    this.props.openActivity(item.activity);
  };

  onAddPostClicked = (item, index) => {
    if (this.props.noActionMode) {
      if (this.props.onActionClickedInNoActionMode) {
        this.props.onActionClickedInNoActionMode();
      }
      return;
    }
    if (this.props.isGuestUser) {
      // this.showDialog({
      //   title: locString('activity.joinRab7ForFurther'),
      //   message: locString('activity.joinRab7ToPost'),
      //   onPositiveClicked: () => {
      //     this.hideDialog();
      //     setTimeout(() => {
      //       this.props.onJoinRab7Clicked(this.props.activity);
      //     }, 100);
      //   },
      //   positiveText: locString('login.joinRab7Short'),
      //   neutralText: locString('generic.later'),
      //   onNeutralClicked: this.hideDialog,
      // });
      this.props.onJoinRab7Clicked(this.props.activity, locString('login.joinRab7Short'), locString('activity.joinRab7ToPost'));
      return;
    }

    let effActivity = this.getEffActivity(item);
    if (!effActivity.withDetails) {
      // fetch the activity complete
      this.fetchActivity(effActivity.id, (activity) => {
        item.activity = activity;
        this.onAddPostClicked(item, index);
      });
      return;
    }
    if (effActivity.needContactNumber) {
      this.props.onUpdateMobileClicked(this.props.activity, locString('activity.updateContactNumber'), locString('activity.mobileRequiredReel'));
      return;
    }
    if (effActivity.isUserActionable) {
      this.pauseItem(index);
      this.props.onAddClicked(effActivity, (data) => {
        const activity = data.activity;
        const post = data.post;
        post.business = activity.business;
        if (activity && post) {
          // if (activity) {
          //   this.activity = activity;
          // }
          post.activity = effActivity;
          const {reels} = this.state;
          reels.data.splice(1, 0, post);
          this.setState({reels: reels, dataChange: !this.state.dataChange,  reload: !this.state.reload}, () => {
            this.playItem(this.state.currentIndex);
          });
        }
      });
    } else {
      let actionDisabledMessage = null;
      if (effActivity.noActionMessage) {
        actionDisabledMessage = effActivity.noActionMessage;
      } else if (DateTimeHelper.getSecondsDiffFromNow(effActivity.startAt) > 0) {
        actionDisabledMessage = DateTimeHelper.getValidity(effActivity.startAt, 'campaign.startIn');
      }
      if (actionDisabledMessage) {
        let onPositiveClicked = null;
        if (effActivity.showCollectMorePoints) {
          onPositiveClicked = () => {
            this.hideDialog();
            // FunInnerScreen.navigateToCollectMore(this.props.navigation, effActivity.cBusinessId)
          };
        }
        this.showDialog({
          title: locString('information'),
          message: actionDisabledMessage,
          onPositiveClicked: onPositiveClicked || this.hideDialog,
          positiveText: effActivity.showCollectMorePoints ? locString('collectMorePoints') : locString('close'),
          neutralText: effActivity.showCollectMorePoints ? locString('close') : null,
          onNeutralClicked: this.hideDialog,
        });
      }
    }
  };

  onBusinessClicked = (item, index) => {
    if (item.business.link) {
      // this.makeCtaActionsInActivity(ACTIVITY_CTA1_ACTION);
      LinkHelper.openLink(item.business.link);
    } else {
      this.onSponsorClicked(item);
    }
  };

  onWinningPostClicked = (index) => {
    // TODO:
    // this.showToast(locString('thisIsWinningPost'));
  };

  onTrendsClicked = (index) => {
    // TODO:
    // ChallengeScreen.navigateTo(this.props.navigation, true);
  }

  onDownloadClicked = (item, index, isWin) => {
    if (item.activity.type === ACTIVITY_TYPE_CHALLENGE || item.activity.type === ACTIVITY_TYPE_CONTENT_WRITING || item.activity.type === ACTIVITY_TYPE_VISITOR_OPINION) {
      const onDownload = () => {
        this.hideDialog();
        this.setState({isBlockedLoading: true, loadingProgress: 0, isDownloadStart: false});
        const onDownloadProgress = (progressEvent) => {
          const percentCompleted = progressEvent.total ? Math.round((progressEvent.loaded * 100) / progressEvent.total) : 0;
          if (this.state.loadingProgress !== percentCompleted) {
            this.stopDownloadInterval();
            this.setState({loadingProgress: Math.max(this.state.loadingProgress, percentCompleted), isDownloadStart: true});
          }
        };
        const onDone = (response) => {
          if (isWin) {
            item.downloadCount = 1;
          } else {
            item.uDownloadCount++;
          }
          this.stopDownloadInterval();
          this.setState({isBlockedLoading: false, loadingProgress: 0});
          const filename = `Rab7-cp${isWin ? '-wd' : ''}-${item.activityId}-${item.id}.${mime.extension(response.data.type)}`;
          fileDownload(response.data, filename, response.data.type);
          this.showSnackbar({snackbarMessage: this.context.intl.formatMessage({id: 'activity.downloadComplete'}), snackbarType: "success"});
        }
        const onError = (response) => {
          this.stopDownloadInterval();
          this.setState({isBlockedLoading: false, loadingProgress: 0});
          this.showDialog({
            title: getErrorFromResponse(response, this.context.intl),
            positiveText: this.context.intl.formatMessage({id: 'generic.ok'}),
            onPositiveClicked: this.hideDialog,
          });
        }
        const onCatch = (response) => {
          const reader = new FileReader();
          reader.onload = () => {
            const data = JSON.parse(reader.result);
            logDebug('', data);
            onError({data: data});
          };
          reader.onerror = () => {
            onError({data: null});
          };
          reader.readAsText(response.data);
        }

        if (isWin || item.activity.type === ACTIVITY_TYPE_VISITOR_OPINION) {
          this.props.downloadActivityPostBusiness(item.id, onDownloadProgress).then(onDone).catch(onCatch);
        } else {
          this.props.downloadActivityPost(item.id, onDownloadProgress).then(onDone).catch(onCatch);
        }
        this.downloadInterval = setInterval(() => {
          const newProgress = this.state.loadingProgress + 0.5;
          if (newProgress > 20) {
            this.stopDownloadInterval();
          }
          this.setState({loadingProgress: newProgress});
        }, 1000);
      };

      const message = isWin && item.downloadCount === 0 ? locString('downloadContentSocialMessage') : locString('downloadContentAgainMessage');
      const dialogInfo = {
        title: this.context.intl.formatMessage({id: 'downloadContent'}),
        message: message,
        positiveText: this.context.intl.formatMessage({id: 'download'}),
        onPositiveClicked: onDownload,
        neutralText: this.context.intl.formatMessage({id: 'generic.cancel'}),
        onNeutralClicked: this.hideDialog,
      };
      this.showDialog(dialogInfo);
    }
  }

  stopDownloadInterval = () => {
    if (this.downloadInterval) {
      clearInterval(this.downloadInterval);
      this.downloadInterval = null;
    }
  }

  getEffActivityType(item) {
    const {activity} = this.props;
    let effActivity = activity;
    if (!effActivity && item) {
      effActivity = item.activity;
    }
    if (effActivity) {
      return effActivity.type;
    }
    return 0;
  }

  getEffActivity(item) {
    const {activity} = this.props;
    let effActivity = activity && activity.id ? activity : null;
    if (!effActivity && item) {
      effActivity = item.activity;
    }
    return effActivity;
  }

  fetchData(page = 1) {
    const {activity} = this.props;
    const {reels, currentIndex} = this.state;
    if (this.props.inPreview) {
      if (reels.page === 1) {
        this.processItemPlayPause(currentIndex, -1, false);
      }
      return;
    }

    let postId = null;
    if (page === 1) {
      postId = this.props.postId;
      this.setState({isFetching: true, error: null, showMenuItem: null, showMenuElement: null});
    } else {
      this.setState({isFetching: true, error: null});
    }
    this.props.fetchData(activity.id, this.props.showcaseId, page, PER_PAGE, postId, activity.type).then(this.onApiSuccess).catch(this.onApiFailure);
  }

  fetchActivity(itemId, onSuccess) {
    this.props.fetchActivity(itemId, this.props.showcaseId, true).then((response) => {
      onSuccess(response.data);
    }).catch((response) => {
      let message = null;
      if (response.data && response.data.error) {
        message = response.data.error;
      } else if (response.error === 'NETWORK_ERROR') {
        message = this.context.intl.formatMessage({id: 'generic.server_not_reachable'});
      } else {
        message = this.context.intl.formatMessage({id: 'generic.server_error_msg'});
      }
      this.showSnackbar({
        snackbarMessage: message,
        snackbarMessageId: !message ? 'somethingWentWrong' : null,
        snackbarType: "error",
      });
    });
  }

  onApiSuccess = (response) => {
    changeNavColor(ColorBlack);
    const {activity, postId} = this.props;
    if (response.data.page === 1 && activity && activity.id > 0) {
      response.data.data.splice(0, 0, {
        id: 0,
        feedType: FEED_TYPE_POST,
        type: POST_TYPE_CHALLENGE,
        details: activity ? (activity.description ? activity.description : activity.title) : null,
        imageUrls: activity ? activity.s2ImageUrl ? [activity.s2ImageUrl] : [activity.imageUrl] : null,
        videoUrl: activity.videoUrl,
        videoStreamUrl: activity.videoStreamUrl,
        audioUrl: activity.bgAudioUrl,
        activity: activity,
        business: activity.business,
        businessId: activity.business.id,
        isDummy: true,
        showHelp: true
      });
    }
    let reels = null;
    let currentIndex = this.state.currentIndex;
    if (response.data.page === 1) {
      reels = response.data;

      this.showRewardsAtLaunch();
      if (postId && response.data.data && response.data.data.length > 1 && response.data.data[1].id == postId) {
        this.swipeUpIndex = 1;
        currentIndex = 1;
      }
    } else {
      reels = this.state.reels;
      if (response.data.data && response.data.data.length > 0) {
        reels.data = reels.data.concat(response.data.data);
      }
      reels.page = response.data.page;
      reels.canLoadMore = response.data.canLoadMore;
    }
    this.setState({reels: reels, currentIndex: currentIndex, isFetching: false, error: null}, () => {
      if (response.data.page === 1) {
        this.processItemPlayPause(currentIndex, -1, false);
      }
    });
  };

  onApiFailure = (response) => {
    let error = null;
    let errorCode = null;
    if (response.data && response.data.error) {
      error = response.data.error;
      errorCode = response.data.errorCode;
    } else if (response.error === 'NETWORK_ERROR') {
      error = this.context.intl.formatMessage({id: 'generic.server_not_reachable'});
    } else {
      error = this.context.intl.formatMessage({id: 'generic.server_error_msg'});
    }
    if (this.props.noActionMode) {
      this.props.onActionClickedInNoActionMode();
      error = this.context.intl.formatMessage({id: this.getNoItemsMessageId()});
    }
    this.setState({isFetching: false, error: error});
  };
}

ActivityReelsView.propTypes = {
  classes: PropTypes.object,
  location: PropTypes.object,
  isLoading: PropTypes.bool,
  localities: PropTypes.array,
  hideActivityModal: PropTypes.func,
  fetchHelp: PropTypes.func,
  showActivityLinkCopiedSnackbar: PropTypes.func,
  showDisplayCriteriaModal: PropTypes.func,
  hideDisplayCriteriaModal: PropTypes.func,
  showActivityCommentModal: PropTypes.func,
  hideActivityCommentModal: PropTypes.func,

  showActivityAnswersModal: PropTypes.func,
  hideActivityAnswersModal: PropTypes.func,
  fetchActivityAnswers: PropTypes.func,
  hideActivityRatingsModal: PropTypes.func,
  fetchActivityRatings: PropTypes.func,
};

ActivityReelsView.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {};
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteActivityPost: (postId) => dispatch(deleteActivityPost(postId)),
    likeActivityPost: (data) => dispatch(likeActivityPost(data)),
    markActivityPostPreviewed: (postId, showcaseId) => dispatch(previewActivityPost(postId, showcaseId)),
    downloadActivityPostBusiness: (postId, onDownloadProgress) => dispatch(downloadActivityPostBusiness(postId, onDownloadProgress)),
    downloadActivityPost: (postId, onDownloadProgress) => dispatch(downloadActivityPost(postId, onDownloadProgress)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(ActivityReelsView));
